import { render } from "./ErrorLog.vue?vue&type=template&id=0639ae18&scoped=true"
const script = {}

import "./ErrorLog.vue?vue&type=style&index=0&id=0639ae18&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0639ae18"]])

export default __exports__